require("jquery-match-height");
module.exports = {
  init: () => {
    $(".product-image").matchHeight();
    $(".matchheight").matchHeight();
    $(".matchheight-min").matchHeight({
      property: "min-height"
    });
  }
};
